// Single source of truth for the e-signature consent disclosure shown before a
// signer applies their signature. Versioned: the version string is persisted on
// each completion (consent_disclosure_version) so we can prove exactly what the
// signer agreed to, even if this copy changes later. Bump the version whenever
// the disclosure text changes.

export const SIGNATURE_DISCLOSURE_VERSION = "1.0";

export const SIGNATURE_DISCLOSURE_HEADING =
  "Electronic Records and Signatures Disclosure";

export const SIGNATURE_DISCLOSURE_POINTS = [
  "Conduct business electronically",
  "Receive documents and notices electronically",
  "Use electronic signatures to sign documents",
  "The legal validity of electronic signatures",
];

export const SIGNATURE_DISCLOSURE_FOOTER =
  "Electronic signatures have the same legal effect as handwritten signatures.";

export const SIGNATURE_CONSENT_LABEL =
  "I agree to use electronic records and signatures";
